import analytics from '@finn-no/analytics';

export default function trackLoginClick() {
    analytics.trackEventLater({
        analyticsName: 'user-admin.log-in.intentional-login',
        eventKpi: 'action',
        stringValue: 'loginbox',
        eventFlags: 'start',
    });
}
